import React from 'react';
import defaultImage from 'src/app/images/placeholders/show-course.jpg';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { AiOutlineTrophy } from 'react-icons/ai';
import moreMedal from 'src/app/images/more-medal.svg';
import { CourseCard, CourseCardBody, CourseCardContent, CourseCardImg, CourseCardImgWrapper, CourseCardSubtitle, CourseCardTitle } from '@/components/custom/course';
import { Badge } from '@/components/ui/badge';
import { CardProgressWrapper } from '@/components/ui/card';

export function LessonMetricsCoursCard(props) {
  const navigate = useNavigate();
  const { course, journey, setShowModal, setSelectedCourse } = props;

  const handleClick = () => {
    setSelectedCourse(course);
    setShowModal(true);
  };

  const downloadCertificate = () => {
    window.open(`${process.env.REACT_APP_DEV_URL}//user_certificates/download/${course?.certificate?.hash_id}.pdf`, '_blank');
  };

  return (
    <CourseCard
      onClick={() => {
        !journey ? navigate(`/curso/acompanhamento/${course?.id}`) : handleClick();
      }}
    >
      <CourseCardBody>
        <CourseCardImgWrapper>
          {/* <Badge size="xs">{course?.knowledge ? course?.knowledge : ''}</Badge> */}
          <CourseCardImg
            size="md"
            src={course?.image?.url || defaultImage}
            alt=""
          />
        </CourseCardImgWrapper>

        <CourseCardContent>
          <CourseCardTitle>{course?.title}</CourseCardTitle>
          <CourseCardSubtitle>
            <strong>{course?.['finished-learning-system-items']}</strong> / {course?.['learning-system-item-count']} {t('dashboard.completedLessons')}
          </CourseCardSubtitle>

          {course?.progress === 100 && new Date(course?.['finished-at']) > new Date() ? (
            <>
              <Badge>
                Aulas concluídas! <b>Continue atento a novos conteúdos.</b>
              </Badge>
              <Badge
                className="mt-2"
                title={`O certificado do curso estará disponível em ${new Date(course?.['finished-at']).toLocaleDateString('pt-br')}`}
              >
                O certificado do curso estará disponível em {new Date(course?.['finished-at']).toLocaleDateString('pt-br')}
              </Badge>
            </>
          ) : course?.progress === 100 && !journey ? (
            <>
              <Badge
                variant="success"
                size="xs"
              >
                Concluído
              </Badge>
              {course?.certificate?.hash_id && (
                <div>
                  <Button
                    variant="link"
                    className="px-0"
                    asChild
                  >
                    <a
                      onClick={e => {
                        e.stopPropagation();
                        downloadCertificate();
                      }}
                    >
                      {t('button.certification')}
                    </a>
                  </Button>
                </div>
              )}
            </>
          ) : (
            <CardProgressWrapper
              percentage={course?.progress}
              toFixed={0}
            />
          )}
        </CourseCardContent>

        {course?.progress === 100 && (
          <div className="medal medal--sm">
            <img
              src={moreMedal}
              alt="nova medalha"
              className="medal__img"
            />
            <span className="medal__value">
              <AiOutlineTrophy />
            </span>
          </div>
        )}
      </CourseCardBody>
    </CourseCard>
  );
}
